import { StoreStateCommon } from "./types";
import { getStoreKey } from "./globals";

export function getCommonState(state: any): StoreStateCommon {
    return state[getStoreKey()];
}
